<template>
	<div class="tabbar" :style="{'padding-bottom': paddingBottomHeight + 'rpx'}">
		<div class="tabbar-item" :class="current == index ? 'tab-active' : ''" v-for="(item, index) in list" :key="index" @click="tabbarChange(item.path)">
			<div class="tabbar-icon">
				<img class="item-img" :src="item.icon_a" v-if="current == index" />
				<img class="item-img" :src="item.icon" v-else />
			</div>
			<span class="unread" v-show="orderBadge > 0 && index == 2"></span>
			<span class="unread" v-show="conversationsqty > 0 && index == 1"></span>
			<div class="item-name" :class="{'tabbarActive': current == index}" v-if="item.text">{{item.text}}</div>
		</div>
	</div>
</template>

<script>
	import {getlogo} from '@/api/api'
	export default {
		props: {
			current: String
		},
		data() {
			return {
				token:"",
				customerService:"",
				paddingBottomHeight: 0, //苹果X以上手机底部适配高度
				list: [{
					text: this.$t('menu.dashboard'),
					icon: require('@/assets/images/tabbar/home.png'),
					icon_a: require('@/assets/images/tabbar/homes.png'),
					path: "", //页面路径
				},{
					// text: this.$t('menu.product'),
					// icon: require('@/assets/images/tabbar/product.png'),
					// icon_a: require('@/assets/images/tabbar/products.png'),
					// path: "product", //页面路径
					text: this.$t('order.customer'),
					icon: require('@/assets/images/tabbar/customer.png'),
					icon_a: require('@/assets/images/tabbar/customer.png'),
					path: "Conversations", //页面路径
				},{
					text: this.$t('menu.order'),
					icon: require('@/assets/images/tabbar/order.png'),
					icon_a: require('@/assets/images/tabbar/orders.png'),
					path: "order-lists", //页面路径
				},{
					text: this.$t('menu.my'),
					icon: require('@/assets/images/tabbar/user.png'),
					icon_a: require('@/assets/images/tabbar/users.png'),
					path: "user", //页面路径
				} ],
				kefuiurl:'',
				orderBadge:0,
				conversationsqty:0
			};
		},
		created() {
			this.initLogo()
		},
		watch: {

		},
		methods: {
			handleBrage(){
				this.conversationsqty = parseInt(localStorage.getItem('cqty') || '0')
				this.orderBadge = parseInt(localStorage.getItem('addOrderqty') || '0')
			},
			tabbarChange(url){
				if(url == 'customer'){
					window.open(this.kefuiurl, '_blank');
				}else{
					this.openPage(url)
				}
			},
			initLogo() {
				var that = this;
				let params = {}
				getlogo(params).then(res => {
					if (res.code == 200) {
						this.kefuiurl = res.data.kefuiurl
					}
				})
			},
		}
	};
</script>

<style scoped>
	.tabbarActive {
		color: #6C77D6 !important;

	}
	.tab-active {

	}

	.tabbar {
		position: fixed;
		bottom: 0;
		width: 100%;
		height: 65px;
		background-color: #fff;
		display: none;
		align-items: center;
		justify-content: space-evenly;
		z-index: 10;
		border-top: 1px solid #F3F3F3;
	}
	.tabbar-item {
		width: 100%;
		height: 100%;
		position: relative;
	}
	.tabbar-item .tabbar-icon {
		width: 100%;
		height: 24px;
		overflow: hidden;
		margin: 11px auto 2px;
	}

	.tabbar-item .item-img {
		width: 24px;
		height: 24px;
		display: block;
		margin: 0 auto;
	}

	.tabbar-item .item-name {
		font-size: 13px;
		height: 20px;
		line-height: 20px;
		color: #878787;
		text-align: center;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
	@media (max-width: 767px) {
		.tabbar {
			display: flex;
		}
	}
	.unread {
		width: 6px;
		height: 6px;
		background-color: red;
		border-radius: 50px;
		position: absolute;
		top: 10px;
		right: 31px;
	}
</style>
